import { useCallback } from "react";

import { LoopConfiguration, LoopType } from "../types";

import { useBlock } from "@/components/PowerBlock/Block/block-store";

export const useLoop = () => {
  const blockStore = useBlock<LoopConfiguration>();

  const { configuration } = blockStore;

  if (!configuration?.loop_type && blockStore.setConfiguration) {
    blockStore.setConfiguration({
      ...configuration,
      loop_type: LoopType.PROMPT,
      max_iterations: configuration?.max_iterations || 10,
    });
  }

  const loopType = configuration?.loop_type || LoopType.PROMPT;

  const setLoopType = useCallback(
    (type: LoopType) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: type,
        prompt_config: type === LoopType.PROMPT ? currentConfig?.prompt_config : undefined,
        workflow_config: type === LoopType.WORKFLOW ? currentConfig?.workflow_config : undefined,
      });
    },
    [blockStore],
  );

  const setPromptConfig = useCallback(
    (promptConfig: LoopConfiguration["prompt_config"]) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: currentConfig?.loop_type || LoopType.PROMPT,
        prompt_config: promptConfig,
      });
    },
    [blockStore],
  );

  const setWorkflowConfig = useCallback(
    (workflowConfig: LoopConfiguration["workflow_config"]) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: currentConfig?.loop_type || LoopType.WORKFLOW,
        workflow_config: workflowConfig,
      });
    },
    [blockStore],
  );

  const setEndConditionJsonPath = useCallback(
    (jsonPath: string | undefined) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: currentConfig?.loop_type || LoopType.PROMPT,
        end_condition_json_path: jsonPath,
      });
    },
    [blockStore],
  );

  const setMaxIterations = useCallback(
    (maxIterations: number | undefined) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: currentConfig?.loop_type || LoopType.PROMPT,
        max_iterations: maxIterations,
      });
    },
    [blockStore],
  );

  const setVariableMappings = useCallback(
    (mappings: Record<string, string>) => {
      const currentConfig = blockStore.configuration;
      blockStore.setConfiguration({
        ...currentConfig,
        loop_type: currentConfig?.loop_type || LoopType.PROMPT,
        variable_mappings: mappings,
      });
    },
    [blockStore],
  );

  return {
    blockStore,
    configuration,
    loopType,
    setLoopType,
    setPromptConfig,
    setWorkflowConfig,
    setEndConditionJsonPath,
    setMaxIterations,
    setVariableMappings,
  };
};
